import React, { Component } from 'react';
import { action, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import Lightbox from 'react-image-lightbox';
import Attachment from './Attachment';
import 'react-image-lightbox/style.css';

@observer
export default class Attachments extends Component {
  @observable selectedAttachment = null;

  constructor() {
    super();
    makeObservable(this);
  }

  @action.bound
  onAttachmentSelected(attachment) {
    this.selectedAttachment = attachment;
  }

  @action.bound
  onAttachmentClose() {
    this.selectedAttachment = null;
  }

  render() {
    const { attachments } = this.props;

    return (
      <div className="row flex-wrap">
        {
          this.selectedAttachment !== null &&
          <Lightbox
            mainSrc={this.selectedAttachment}
            reactModalStyle={{ overlay: { zIndex: 1e5 } }}
            onCloseRequest={this.onAttachmentClose}
          />
        }

        {
          attachments.map((attachment, idx) =>
            <Attachment
              key={idx}
              attachment={attachment}
              onAttachmentSelected={this.onAttachmentSelected}
              type={this.props.type}
            />
          )
        }
      </div>
    );
  }
}
